// GeoComply geolocation reason codes — the FULL list from the GeoComply
// "Geolocation Request Reason" sheet:
// https://docs.google.com/spreadsheets/d/15q0KAZ1s-Wknenn3U3XiFePBJaLmRpr_u0e46ryyrXo
//
// `code` is the operator reason code (sent as the SDK reason_code). Most are
// plain integers; the 9x/10x/11x/12x fraud-check rows are sub-coded exactly as
// the sheet lists them. The Reason-code control shows ALL of these.
export const REASON_CODES = [
  { code: '1',  name: 'Login' },
  { code: '2',  name: 'Pre-wager' },
  { code: '3',  name: 'Interval' },
  { code: '4',  name: 'IP Change' },
  { code: '5',  name: 'UserDrivenRetry' },
  { code: '6',  name: 'Post Interval — Foreground' },
  { code: '7',  name: 'Game Launch / Switch' },
  { code: '8',  name: 'Registration' },
  { code: '9a', name: 'Account changes — Name — Add' },
  { code: '9b', name: 'Account changes — Name — Change' },
  { code: '9c', name: 'Account changes — Name — Remove' },
  { code: '9d', name: 'Account changes — Phone — Add' },
  { code: '9e', name: 'Account changes — Phone — Change' },
  { code: '9f', name: 'Account changes — Phone — Remove' },
  { code: '9g', name: 'Account changes — Email — Add' },
  { code: '9h', name: 'Account changes — Email — Change' },
  { code: '9i', name: 'Account changes — Email — Remove' },
  { code: '9j', name: 'Account changes — Password' },
  { code: '9k', name: 'Account changes — Security — Add' },
  { code: '9l', name: 'Account changes — Security — Remove' },
  { code: '9m', name: 'Account changes — Physical Address — Add' },
  { code: '9n', name: 'Account changes — Physical Address — Change' },
  { code: '9o', name: 'Account changes — Physical Address — Remove' },
  { code: '9p', name: 'Account changes — Contacts — Add' },
  { code: '9q', name: 'Account changes — Contacts — Change' },
  { code: '9r', name: 'Account changes — Contacts — Remove' },
  { code: '10a', name: 'Payment information — Add funding method' },
  { code: '10b', name: 'Payment information — Change funding method' },
  { code: '10c', name: 'Payment information — Remove funding method' },
  { code: '10d', name: 'Payment information — Add withdrawal method' },
  { code: '10e', name: 'Payment information — Change withdrawal method' },
  { code: '10f', name: 'Payment information — Remove withdrawal method' },
  { code: '11a', name: 'Transaction — Deposit' },
  { code: '11b', name: 'Transaction — Withdrawal' },
  { code: '11c', name: 'Transaction — Purchase / Wager' },
  { code: '11d', name: 'Transaction — Sell' },
  { code: '11e', name: 'Transaction — Transfer — Same user' },
  { code: '11f', name: 'Transaction — Transfer — Different user' },
  { code: '12a', name: 'Navigation — Balance' },
  { code: '12b', name: 'Navigation — Transaction History' },
  { code: '12c', name: 'Navigation — Transaction details' },
  { code: '12d', name: 'Navigation — Profile' },
  { code: '12e', name: 'Navigation — Help Center' },
  { code: '12f', name: 'Navigation — Terms of use' },
  { code: '12g', name: 'Navigation — Contacts' },
];

const NAME_BY_CODE = REASON_CODES.reduce((m, r) => { m[String(r.code)] = r.name; return m; }, {});

// Friendly name for a reason code. Falls back to the raw value for unknowns.
export function reasonName(code) {
  if (code == null || code === '') return '--';
  return NAME_BY_CODE[String(code)] || String(code);
}
